export default "__VITE_ASSET__BCDTbYGz__"